import { render, staticRenderFns } from "./shippingTemplates.vue?vue&type=template&id=74129baa"
import script from "./shippingTemplates.vue?vue&type=script&lang=js"
export * from "./shippingTemplates.vue?vue&type=script&lang=js"
import style0 from "./shippingTemplates.vue?vue&type=style&index=0&id=74129baa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports